import { render, staticRenderFns } from "./UpdateAffirm.vue?vue&type=template&id=cfd729ac&"
import script from "./UpdateAffirm.vue?vue&type=script&lang=js&"
export * from "./UpdateAffirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports